import {computed, ComputedRef} from "vue"
import bookingData from "@/computed/bookingData"
import { IGlobalInsurance } from "@/model/Insurance/GlobalInsurance"

const annulationOption: ComputedRef<IGlobalInsurance | null> = computed(() => {
    const annulationFamily = bookingData.value.insuranceFamiliesMap.get("3")
    if (!annulationFamily) return null
    return annulationFamily.getInsurances()[0] as IGlobalInsurance
})

export default annulationOption